/**
 * @generated SignedSource<<d8054a38aa0ee0bda66fc1912a2d0db0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion$data = {
  readonly id: string;
  readonly section: {
    readonly assignedTeam: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
    } | null;
    readonly id: string;
  };
  readonly title: string | null;
  readonly " $fragmentType": "RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion";
};
export type RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion$key = {
  readonly " $data"?: RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamIconCircleComponent_Team"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineSectionVersion",
  "abstractKey": null
};
})();

(node as any).hash = "7b4226bbc987aa672e64c9f8d1ac700f";

export default node;
